import { useRef, useState, useContext, forwardRef, useImperativeHandle } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { MessageSquare } from "react-feather";
import { recordManualResponse } from "../../../services/campaign";
import NotyfContext from "../../../contexts/NotyfContext";

const ManualResponse = forwardRef(({ afterSubmit, campaignId, disabled }, ref) => {
  const [show, setShow] = useState(false);
  const [familyId, setFamilyId] = useState("");
  const [loading, setLoading] = useState(false);
  const notyf = useContext(NotyfContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!familyId.trim()) {
      notyf.error("Please enter a Family ID");
      return;
    }

    const numericFamilyId = parseInt(familyId.trim());
    if (isNaN(numericFamilyId)) {
      notyf.error("Please enter a valid numeric Family ID");
      return;
    }

    setLoading(true);
    try {
      await recordManualResponse(campaignId, numericFamilyId);
      notyf.success("Manual response recorded successfully!");
      setShow(false);
      setFamilyId("");
      if (afterSubmit) {
        await afterSubmit();
      }
    } catch (error) {
      const message =
        error?.[0]?.description || error.message || "Something went wrong";
      notyf.error(message);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShow(false);
    setFamilyId("");
  };

  const handleShow = () => {
    if (disabled) return;
    setShow(true);
  };

  useImperativeHandle(ref, () => ({
    setShow: (show) => setShow(show)
  }));

  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Record Manual Response</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Form.Group>
              <Form.Label>Family ID</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter Family ID"
                value={familyId}
                onChange={(e) => setFamilyId(e.target.value)}
                required
              />
              <Form.Text className="text-muted">
                Enter the numeric ID of the family to record a manual response for.
              </Form.Text>
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button 
              variant="warning" 
              type="submit" 
              disabled={loading}
            >
              {loading ? "Recording..." : "Record Response"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
});

export default ManualResponse; 